(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ps-card"] && !Shopify.designMode) return;
  try {
    if (!window.__psqv) {
  window.__psqv = true;

  var RANK = { 'Near Mint': 1, 'Lightly Played': 2, 'Moderately Played': 3, 'Heavily Played': 4, 'Damaged': 5 };
  var ABBR = { 'Near Mint': 'NM', 'Lightly Played': 'LP', 'Moderately Played': 'MP', 'Heavily Played': 'HP', 'Damaged': 'DMG' };
  var dlg = null;
  var state = null;

  var money = function (cents) {
    return (cents / 100).toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var q = function (sel) { return dlg.querySelector(sel); };

  var setMsg = function (html, isErr) {
    var m = q('.psqv__msg');
    m.innerHTML = html || '';
    m.classList.toggle('psqv__msg--err', !!isErr);
  };

  var closeDlg = function () { if (dlg && dlg.open) dlg.close(); };

  var build = function () {
    dlg = document.createElement('dialog');
    dlg.className = 'psqv';
    dlg.setAttribute('aria-label', 'Kortdetaljer');
    dlg.innerHTML =
      '<div class="psqv__box">' +
        '<button type="button" class="psqv__close" aria-label="Lukk">&times;</button>' +
        '<div class="psqv__grid">' +
          '<div class="psqv__media"><img class="psqv__img" alt=""><div class="psqv__thumbs"></div></div>' +
          '<div class="psqv__info">' +
            '<h2 class="psqv__title"></h2>' +
            '<p class="psqv__set"></p>' +
            '<p class="psqv__label"></p>' +
            '<div class="psqv__conds"></div>' +
            '<p class="psqv__price"></p>' +
            '<p class="psqv__tax">Avgift er inkludert i prisen etter avansemetoden og er ikke fradragsberettiget som inngående MVA. <a href="/policies/shipping-policy">Frakt</a> beregnes ved kassen.</p>' +
            '<p class="psqv__stock"></p>' +
            '<button type="button" class="psqv__add">Legg i kurv</button>' +
            '<div class="psqv__wish"></div>' +
            '<p class="psqv__msg" role="status" aria-live="polite"></p>' +
            '<a class="psqv__full" href="#">Se hele kortsiden &rarr;</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);

    q('.psqv__close').addEventListener('click', closeDlg);
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDlg();
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('psqv-lock');
      if (state && state.opener && state.opener.focus) {
        try { state.opener.focus({ preventScroll: true }); } catch (err) {}
      }
    });
    q('.psqv__add').addEventListener('click', function () {
      if (state && state.sel) addToCart(state.sel.id, this, true);
    });
  };

  var select = function (v) {
    state.sel = v;
    Array.prototype.forEach.call(dlg.querySelectorAll('.psqv__cond'), function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-id') === String(v.id)));
    });
    q('.psqv__price').textContent = money(v.p);
    var st = q('.psqv__stock');
    var low = v.m && v.q <= 1;
    st.className = 'psqv__stock ' + (low ? 'psqv__stock--low' : 'psqv__stock--in');
    st.textContent = ((state.d.slab || v.t === 'Default Title') ? '' : v.t + ' · ') + (low ? 'Siste eksemplar' : 'På lager');
    setMsg('');
  };

  var showImg = function (i) {
    var src = state.d.img[i];
    if (!src) return;
    q('.psqv__img').src = src;
    Array.prototype.forEach.call(dlg.querySelectorAll('.psqv__thumb'), function (b, j) {
      b.setAttribute('aria-pressed', String(j === i));
    });
  };

  var openQV = function (d, opener) {
    if (!dlg) build();
    state = { d: d, opener: opener, sel: null };

    q('.psqv__img').alt = d.title;
    q('.psqv__title').textContent = d.title;
    q('.psqv__set').textContent = d.set || '';
    q('.psqv__full').href = d.url;
    q('.psqv__label').textContent = d.slab ? 'Gradering' : 'Tilstand';
    q('.psqv__label').style.display = '';

    var thumbs = q('.psqv__thumbs');
    thumbs.innerHTML = '';
    var imgs = (d.img || []).filter(Boolean);
    d.img = imgs;
    if (d.slab && imgs.length > 1) {
      imgs.forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'psqv__thumb';
        b.setAttribute('aria-label', i === 0 ? 'Forside' : 'Bakside');
        b.innerHTML = '<img src="' + esc(src) + '" alt="">';
        b.addEventListener('click', function () { showImg(i); });
        thumbs.appendChild(b);
      });
    }
    showImg(0);

    var vs = (d.v || []).filter(function (v) { return v.a; }).sort(function (a, b) {
      return (RANK[a.t] || 9) - (RANK[b.t] || 9);
    });
    var conds = q('.psqv__conds');
    conds.innerHTML = '';
    var noCond = vs.length === 1 && vs[0].t === 'Default Title';
    if (noCond) q('.psqv__label').style.display = 'none';
    if (!noCond) vs.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'psqv__cond';
      b.setAttribute('data-id', v.id);
      b.setAttribute('title', v.t);
      var name = d.slab ? v.t.split(' - ')[0] : (ABBR[v.t] || v.t);
      b.innerHTML = esc(name) + '<small>' + esc(money(v.p)) + '</small>';
      b.addEventListener('click', function () { select(v); });
      conds.appendChild(b);
    });

    var wish = q('.psqv__wish');
    wish.innerHTML = '';
    if (d.handle) {
      var w = document.createElement('wishlist-button-collection');
      w.setAttribute('data-product-handle', d.handle);
      w.setAttribute('show-icon', '');
      w.setAttribute('show-text', '');
      w.setAttribute('full-width', '');
      wish.appendChild(w);
    }

    var add = q('.psqv__add');
    add.disabled = false;
    add.textContent = 'Legg i kurv';
    if (vs.length) {
      select(vs[0]);
    } else {
      q('.psqv__price').textContent = '';
      q('.psqv__stock').className = 'psqv__stock psqv__stock--out';
      q('.psqv__stock').textContent = 'Utsolgt';
      add.disabled = true;
      setMsg('');
    }

    document.documentElement.classList.add('psqv-lock');
    dlg.showModal();
    dlg.scrollTop = 0;
  };

  var updateBubble = function (sections) {
    var html = sections && sections['cart-icon-bubble'];
    var el = document.getElementById('cart-icon-bubble');
    if (!html || !el) return;
    var t = document.createElement('div');
    t.innerHTML = html;
    var src = t.querySelector('.shopify-section') || t;
    el.innerHTML = src.innerHTML;
    el.classList.remove('ps-cart-pulse');
    void el.offsetWidth;
    el.classList.add('ps-cart-pulse');
    setTimeout(function () { el.classList.remove('ps-cart-pulse'); }, 700);
  };

  var addToCart = function (id, btn, inDialog) {
    var orig = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Legger til …';

    // Ingen kurv-popup her (Aaron 8. okt): bare tallet i kurvikonet
    // oppdateres og pulserer, og knappen viser «Lagt i kurv ✓».
    var body = {
      id: id,
      quantity: 1,
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname
    };

    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        var d = res.d;
        if (!res.ok || d.status) {
          var err = new Error(d.status === 422 ? 'full' : 'fail');
          throw err;
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ps-quickview', productVariantId: id, cartData: d }); } catch (e) {}
        }
        updateBubble(d.sections);
        if (inDialog) setMsg('Lagt i kurven ✓ <a href="' + ((window.routes && window.routes.cart_url) || '/cart') + '">Gå til kurven</a>');
        btn.textContent = 'Lagt i kurv ✓';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 1800);
      })
      .catch(function (e) {
        var full = e && e.message === 'full';
        if (inDialog) {
          btn.innerHTML = orig;
          btn.disabled = false;
          setMsg(full ? 'Du har allerede alle vi har av dette kortet i kurven.' : 'Noe gikk galt. Prøv igjen.', true);
        } else {
          btn.textContent = full ? 'Alle er i kurven' : 'Prøv igjen';
          setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2200);
        }
      });
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ps-qv]');
    if (!t) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof HTMLDialogElement !== 'function') return;
    var card = t.closest('.ps-card');
    var raw = card && card.querySelector('script.ps-qv-data');
    if (!raw) return;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (err) { return; }
    e.preventDefault();
    openQV(data, t);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-ps-add]');
    if (!f) return;
    e.preventDefault();
    var b = f.querySelector('button[type="submit"]');
    if (b && !b.disabled) addToCart(parseInt(f.getAttribute('data-ps-add'), 10), b, false);
  });
}
  } catch(e) { console.error(e); }
})();

})();
